import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

// services
import * as moment from 'moment';
// models
import { ReportPayload } from 'src/app/reports/models/report-payload';
import { ReportCategory } from 'src/app/reports/models/report-category';
import { ReportTableColumn } from 'src/app/reports/models/report-table';
import { BasicReportData } from 'src/app/reports/models/report-viewers';
import { ReportService } from 'src/app/reports/services/report.service';
import { ReportType } from 'src/app/reports/models/report-types';

@Component({
  selector: 'app-report-events',
  templateUrl: './report-events.component.html',
  styleUrls: ['./report-events.component.scss',  './../../report-viewer.component.scss']
})
export class ReportEventsComponent implements OnInit {
  @Input() report! : ReportPayload;
  @Input() category! : ReportCategory;
  @Input() columns! : ReportTableColumn[];

  basicData? : any;

  public reportType = ReportType;

  constructor(
    private reportService: ReportService
  ) { }

  ngOnInit(): void {  
    this.updateReport();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['report']) {
      this.updateReport(); // o lo que necesites ejecutar
    }
  }

  // Para obtener columnas de cada reporte
  getColumns(report: any): string[] {
    return report[1][0]; // primer array son los encabezados
  }

  // Para obtener los registros de cada reporte
  getRows(report: any): any[] {
    return report[1].slice(1); // resto de arrays son los registros
  }
  updateReport(){
    this.formatReportTable();
  }

  // FUNCIONTS
  formatReportTable(){
    this.basicData = this.report.data;
  }

}
